import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0df517cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "alku",
  class: "FrontPage"
}
const _hoisted_2 = { class: "PageArea NormalPaddings" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Edesmenneet henget", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Välitämme Taivaasta teille ystäväisemme rakkaudella iloksenne ja opiksenne erilaisia viestejä. Ne voivat olla runoja, tarinoita, mitä vaan maan ja taivaan väliltä. Poimi itsellesi sopivin. Toivottavasti se auttaa sinua löytämään elämääsi iloa, naurua, terveyttä ja uskoa meihin, jotka olemme menneet teitä ennen Taivaaseen. Täällähän me olemme 🧡 ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Rakkaudella henget!", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  id: "elaimet",
  class: "AnimalArea NormalPaddings"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Edesmenneiden eläinten henget 🦊🐎🐁", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Heippa teille kaikille!"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Olemme suloinen joukko eläimiä, jotka kertovat täältä Ylhäältä teille viestejä maanpäällisistä tapahtumistamme ja Yläkerran elämästämme. Me olemme kaikki eläinlajit matelijoista nisäkkäisiin toistemme kanssa hyviä kavereita. Vaikka maanpäällä gaselli joutui juoksemaan karkuun metsästävää leijonaa niin Ylhäällä ei enää syödä toisiamme tai tehdä muutenkaan mitään kurjaa toisillemme. Katselemme välillä maanpäällistä elämää ja saatamme piipahtaa tökkäämässä kuonolla omistajamme jalkaa. ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Iloisia ja rakastavia hetkiä viestiemme parissa! 🦒", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  id: "peikot",
  class: "GoblinArea NormalPaddings"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Peikot", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Peikot halusivat tulla esittäytymään ihmisille. Ensin he kertovat minkälaisia nimiä heillä on: \"Meillä on monenlaisia nimiä kuten esimerkiksi Paka, Sanka, Veis, Mähel, Misva, Kalikali, Sanki, Oiveri, Mili, Mini Mili, Manki, Orvo, Jaski, Salki, Soo, Jihi, Sankra, Jermi, Joosa, Kolisi, Kooa, Salisuu, Ontoppa ja Raae.\" ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Rakkaudella henget!", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "NatureArea NormalPaddings" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Luonnonhenget 🌼", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Hei, kaksijalkaiset olennot. Olemme halunneet tulla esittäytymään ihmisille, jotta ymmärtäisitte että maailmassanne on ympärillä paljon asioita joita te ette tiedosta. Mistä tulee sadut maahisista, peikoista, tontuista, näkeistä, yksisarvisista ja lukemattomista muista luonnossa esiintyvistä hengistä? Luuletko todella, että ne ovat keksittyjä tarinoita, satuja? Ei pidä paikkaansa. ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Me olemme todellisia ja meillä kaikilla on luonnossa tärkeät tehtävät, jotta tasapaino maapallolla säilyisi. Voi teitä ihmisiä! Mitä olette tehneet? Ettekö ole ihmetelleet miksi te ette näe meitä? Aikoinaan olette eläneet meidän kanssa rinta rinnan. ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Nyt ollaan tultu siihen, että maapallon aika on miltei lopussa. Me taistelemme, jotta näin ei käy. Siksi tulemme esittäytymään teille, että alatte ymmärtämään kuinka ihmisen tulee muuttua ja alkaa kunnioittamaan maapalloa. Pelastetaan elinympäristömme yhdessä 💚 ", -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Pahus! Nyt pätkii sen verran pahasti, että viestit on kadoksissa. Kannattaa yrittää myöhemmin uudelleen. ", -1))
const _hoisted_25 = [
  _hoisted_24
]

import { SpiritMessage } from "@/models";
import { onMounted, reactive } from "vue";
import SpiritMessageBox from "../components/SpiritMessageBox.vue";
import HomeButton from "../components/HomeButton.vue";
import Proxy from "../api/proxy";

interface State {
  Title: string;
  BodyHtml: string;
  showError: boolean;
  showMessages: boolean;
  messages: SpiritMessage[];
  showAnimals: boolean;
  animalmessages: SpiritMessage[];
  showGoblins: boolean;
  goblinmessages: SpiritMessage[];
  showNature: boolean;
  naturemessages: SpiritMessage[];
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = reactive<State>({
  Title: "",
  BodyHtml: "",
  showError: false,
  showMessages: false,
  messages: [],
  showAnimals: false,
  animalmessages: [],
  showGoblins: false,
  goblinmessages: [],
  showNature: false,
  naturemessages: [],
});

const proxy = new Proxy();

onMounted(() => {
  fetchMessages();
  fetchAnimalMessages();
  fetchGoblinMessages();
  fetchNatureMessages();
});

async function fetchMessages() {
  proxy
    .getSpiritMessages("people")
    .then((r) => {
      state.messages = r;
      state.showMessages = true;
    })
    .catch(() => {
      state.showError = true;
      state.showMessages = false;
    });
}
async function fetchAnimalMessages() {
  proxy
    .getSpiritMessages("animals")
    .then((r) => {
      state.animalmessages = r;
      state.showAnimals = true;
    })
    .catch(() => {
      state.showError = true;
      state.showAnimals = false;
    });
}
async function fetchGoblinMessages() {
  proxy
    .getSpiritMessages("goblins")
    .then((r) => {
      state.goblinmessages = r;
      state.showGoblins = true;
    })
    .catch(() => {
      state.showError = true;
      state.showGoblins = false;
    });
}
async function fetchNatureMessages() {
  proxy
    .getSpiritMessages("nature")
    .then((r) => {
      state.naturemessages = r;
      state.showNature = true;
    })
    .catch(() => {
      state.showError = true;
      state.showNature = false;
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      (_unref(state).showMessages)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).messages, (excerpt) => {
              return (_openBlock(), _createElementBlock("div", {
                key: excerpt.id,
                class: "Entry"
              }, [
                _createVNode(SpiritMessageBox, {
                  id: excerpt.id,
                  title: excerpt.title,
                  shortened: excerpt.lines[0],
                  category: "People"
                }, null, 8, ["id", "title", "shortened"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(HomeButton)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      (_unref(state).showAnimals)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).animalmessages, (excerpt) => {
              return (_openBlock(), _createElementBlock("div", {
                key: excerpt.id,
                class: "Entry"
              }, [
                _createVNode(SpiritMessageBox, {
                  id: excerpt.id,
                  title: excerpt.title,
                  shortened: excerpt.lines[0],
                  category: "Animals"
                }, null, 8, ["id", "title", "shortened"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(HomeButton)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      (_unref(state).showGoblins)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).goblinmessages, (excerpt) => {
              return (_openBlock(), _createElementBlock("div", {
                key: excerpt.id,
                class: "Entry"
              }, [
                _createVNode(SpiritMessageBox, {
                  id: excerpt.id,
                  title: excerpt.title,
                  shortened: excerpt.lines[0],
                  category: "Goblins"
                }, null, 8, ["id", "title", "shortened"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(HomeButton)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _hoisted_19,
      _hoisted_20,
      _hoisted_21,
      (_unref(state).showNature)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).naturemessages, (excerpt) => {
              return (_openBlock(), _createElementBlock("div", {
                key: excerpt.id,
                class: "Entry"
              }, [
                _createVNode(SpiritMessageBox, {
                  id: excerpt.id,
                  title: excerpt.title,
                  shortened: excerpt.lines[0],
                  category: "Nature"
                }, null, 8, ["id", "title", "shortened"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(HomeButton)
    ]),
    (_unref(state).showError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
      : _createCommentVNode("", true)
  ]))
}
}

})